import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { GfTitleService } from '../../../../services/core.title.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'confirm-view',
  template: require('./confirm.component.html')
})
export class ConfirmViewComponent implements OnInit {
  @Input() registrationMode: any;
  @Input() msg: any;
  @Input() email: string = '';

  token: string = '';
  errors: { email: boolean; token: boolean } = { email: false, token: false };
  confirming: boolean = false;

  constructor(
    private stateService: StateService,

    private uiService: UiService,
    private translateService: GfTranslateService,
    private titleService: GfTitleService
  ) {}

  ngOnInit() {
    this.titleService.setTitle(this.translateService.translate('Confirm Registration'));

    // Use input email if provided, otherwise get from state params
    if (!this.email) {
      this.email = decodeURIComponent(_.get(this.stateService.params, 'email', ''));
    }
    this.token = _.get(this.stateService.params, 'token', '');

    this.errors = {
      email: false,
      token: false
    };

    setTimeout(() => {
      this.setInitialFocus();
    }, 1000);
  }

  private setInitialFocus() {
    if (this.email === '') {
      this.uiService.setFocus('email');
    } else if (this.token === '') {
      this.uiService.setFocus('token');
    }
  }

  protected validateForm(): boolean {
    this.errors.email = !this.email?.length;
    this.errors.token = !this.token?.length;
    return !this.errors.email && !this.errors.token;
  }

  confirm() {
    if (!this.validateForm()) {
      return;
    }

    const params = {
      email: this.email,
      token: this.token
    };

    this.confirming = true;
    setTimeout(() => {
      this.stateService.go('.', params, { reload: true });
    });
  }
}